import { render, staticRenderFns } from "./product-banner.vue?vue&type=template&id=2c0339f2&scoped=true&lang=html&"
import script from "./product-banner.vue?vue&type=script&lang=js&"
export * from "./product-banner.vue?vue&type=script&lang=js&"
import style0 from "./product-banner.vue?vue&type=style&index=0&id=2c0339f2&lang=scss&scoped=true&"
import style1 from "./product-banner.vue?vue&type=style&index=1&lang=scss&module=skuMain&"
import style2 from "./product-banner.vue?vue&type=style&index=2&lang=css&"




function injectStyles (context) {
  
  this["skuMain"] = (style1.locals || style1)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2c0339f2",
  null
  
)

export default component.exports